import { type ReactElement } from 'react'

import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { CertificateGeneratorSkeleton } from '../shared/components/certificate-generator-skeleton.tsx'
import { FieldSkeleton } from '../shared/components/field-skeleton.tsx'
import { FormRow } from '../shared/components/form-row.tsx'

/**
 * Pending state for `InsuranceCertificateGeneratorRealEstateSalesAgentsPage`: the three form rows,
 * then the representatives section, which always renders at least one representative.
 */
export function InsuranceCertificateGeneratorRealEstateSalesAgentsPageSkeleton(): ReactElement {
  return (
    <CertificateGeneratorSkeleton>
      <Section.Root>
        <FormRow>
          <FieldSkeleton />
          <FieldSkeleton />
        </FormRow>
        <FormRow>
          <FieldSkeleton />
          <FieldSkeleton />
          <FieldSkeleton />
        </FormRow>
        <FormRow>
          <FieldSkeleton />
          <FieldSkeleton />
        </FormRow>
      </Section.Root>

      <Section.Root>
        {/* Title on the left, the 32px add-representative button on the right. */}
        <Section.Header>
          <Skeleton variant="text" width={160} height={24} />
          <Section.Actions>
            <Skeleton variant="block" width={32} height={32} />
          </Section.Actions>
        </Section.Header>
        <Section.Body>
          <FormRow>
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
          </FormRow>
        </Section.Body>
      </Section.Root>
    </CertificateGeneratorSkeleton>
  )
}
